import "./FoodImage.css";
import FoodBadges from "../FoodBadges/FoodBadges";
import getImageUrl from "../../../../../../../utils/imageUrl";

function FoodImage({ food }) {
  const imageUrl = food.image
    ? getImageUrl(food.image)
    : "/images/food-placeholder.png";

  return (
    <div className="food-image-wrapper">
      <img
        src={imageUrl}
        alt={food.foodName || "Food"}
        className="food-image"
        onError={(event) => {
          event.currentTarget.src =
            "/images/food-placeholder.png";
        }}
      />

      <FoodBadges food={food} />
    </div>
  );
}

export default FoodImage;